import { forwardRef } from 'react'

import { StyledArrowLink, Content, Arrow } from './styles'

export const ArrowLink = forwardRef(
  ({ link, children, fontSize, colorArrow, ...linkProps }, ref) => (
    <StyledArrowLink
      href={link}
      className="arrow-link"
      data-cy="arrow_link"
      fontSize={fontSize}
      {...linkProps}
      alt={link}
    >
      <Content ref={ref}>
        {children}
        <Arrow $colorArrow={colorArrow} />
      </Content>
    </StyledArrowLink>
  )
)
